<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} CONTRAT</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, initVal()" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <div class="mt-5">
                    <vs-input type="number" v-model="code_contract"
                              :danger="errors_data.code_contract ? true : false"
                              :danger-text="errors_data.code_contract ? errors_data.code_contract[0] : ''"
                              class="w-full" label="Code contrat"></vs-input>
                </div>
                <div class="mt-5">
                    <vs-input type="date" v-model="date_debut"
                              :danger="errors_data.date_debut ? true : false"
                              :danger-text="errors_data.date_debut ? errors_data.date_debut[0] : ''"
                              class="w-full" label="Date de début"></vs-input>
                </div>
                <div class="mt-5">
                  <vs-input type="date" class="w-full"
                            :danger="errors_data.date_fin ? true : false"
                            :danger-text="errors_data.date_fin ? errors_data.date_fin[0] : ''"
                            v-model="date_fin"
                            label="Date de fin"></vs-input>
                </div>
                <div class="mt-5">
                  <vs-input type="date" class="w-full"
                            v-model="signer_le"
                            :danger="errors_data.signer_le ? true : false"
                            :danger-text="errors_data.signer_le ? errors_data.signer_le[0] : ''"
                            label="Date de signature"></vs-input>
                </div>
                <vs-select v-model="service"
                           :danger="errors_data.service ? true : false"
                           :danger-text="errors_data.service ? errors_data.service[0] : ''"
                           label="Services liés" class="mt-5 w-full"
                           name="item-category" multiple :closeOnSelect="true">
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in services" />
                </vs-select>

              <div class="mt-5">
                <vs-checkbox v-model="default_contract">Contrat par défaut</vs-checkbox>
                <span v-if="errors_data.default_contract" style="color: red; font-size: 10px">Ce client à déjà un contrat par défaut</span>
              </div>
                <vs-textarea label="Notes" v-model="description" class="mt-5 w-full" />
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="saveOrUpdate()" class="mr-6">Enregistrer</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, initVal()">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>


<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import Datepicker from 'vuejs-datepicker';
    export default {
        components: {VuePerfectScrollbar, Datepicker},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
          services:{
              type: Array,
              default: () => []
          },
            data: {
                type: Object,
                default: () => {},
            },
          getContracts:{
              type: Function
          }
        },
      watch: {
        isSidebarActive(val) {
          if(!val) return;
          if(Object.entries(this.data).length === 0) {
            this.initVal()
          } else {
            let { id, customer_id, date_debut, date_fin, signer_le, default_contract, description, service, code_contract } = JSON.parse(JSON.stringify(this.data));
            this.dataId = id
            this.code_contract = code_contract
            this.customer_id = customer_id
            this.date_debut = date_debut
            this.date_fin = date_fin
            this.signer_le = signer_le
            this.service = service
            this.default_contract = default_contract
            this.description = description
            //this.initValues();

          }
        },
      },
        data() {
            return {
                errors_data: [],
                dataId: null,
                date_debut: '',
                date_fin: '',
                signer_le: '',
                service: [],
                default_contract: false,
                description: '',
              customer_id: '',
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                }
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }

            },
        },
        methods: {
          initVal(){
            this.dataId = null
              this.date_debut = null
              this.date_fin = null
              this.signer_le = null
              this.service = []
              this.default_contract = false
              this.description = null,
                this.customer_id =  ''
            this.errors_data = []
          },
            saveData() {
              this.$vs.loading()
              this.$http.post('/contracts/save', {
                date_debut: this.date_debut,
                date_fin: this.date_fin,
                signer_le: this.signer_le,
                service: this.service,
                default_contract: this.default_contract,
                customer_id: this.$route.params.id,
                description: this.description
              }).then(() =>{
                this.$vs.loading.close()
                this.$emit('closeSidebar')
                this.errors_data = []
                this.getContracts()
              }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                  this.$router.push('/login')
                }else this.errors_data = error.response.data.errors
              })
            },
          updateData(){
            this.$vs.loading()
            this.$http.post('/contracts/update', {
              id: this.dataId,
              code_contract: this.code_contract,
              date_debut: this.date_debut,
              date_fin: this.date_fin,
              signer_le: this.signer_le,
              service: this.service,
              default_contract: this.default_contract,
              customer_id: this.$route.params.id,
              description: this.description
            }).then(() =>{
              this.$vs.loading.close()
              this.$emit('closeSidebar')
              this.errors_data = []
              this.getContracts()
            }).catch((error) => {
              this.$vs.loading.close()
              if (error.response.status === 401){
                this.$router.push('/login')
              }else this.errors_data = error.response.data.errors
            })
          },
          saveOrUpdate(){
            if (this.dataId){
              this.updateData()
            }else this.saveData()
          }
        }
    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>
